.photo {
  position: absolute;
  inset: 0;
  overflow: hidden;
  background-image: var(--arrival-scene), var(--chekin-gradient-hero);
  background-size: cover, cover;
  background-position: center 62%, center center;
  background-repeat: no-repeat, no-repeat;
  transform: scale(1.02);

  --arrival-scene: url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20400%20280%22%20preserveAspectRatio%3D%22xMidYMid%20slice%22%3E%3Cdefs%3E%3ClinearGradient%20id%3D%22sk%22%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%220%22%20y2%3D%221%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%2315153f%22%2F%3E%3Cstop%20offset%3D%22.34%22%20stop-color%3D%22%232e46c8%22%2F%3E%3Cstop%20offset%3D%22.6%22%20stop-color%3D%22%235975f5%22%2F%3E%3Cstop%20offset%3D%22.8%22%20stop-color%3D%22%238ca5ff%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ffb700%22%2F%3E%3C%2FlinearGradient%3E%3CradialGradient%20id%3D%22gl%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23ffb700%22%20stop-opacity%3D%22.85%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ffb700%22%20stop-opacity%3D%220%22%2F%3E%3C%2FradialGradient%3E%3ClinearGradient%20id%3D%22se%22%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%220%22%20y2%3D%221%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%235975f5%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23161643%22%2F%3E%3C%2FlinearGradient%3E%3C%2Fdefs%3E%3Crect%20width%3D%22400%22%20height%3D%22280%22%20fill%3D%22url%28%23sk%29%22%2F%3E%3Ccircle%20cx%3D%22286%22%20cy%3D%22152%22%20r%3D%2262%22%20fill%3D%22url%28%23gl%29%22%2F%3E%3Ccircle%20cx%3D%22286%22%20cy%3D%22152%22%20r%3D%2217%22%20fill%3D%22%23fff%22%20opacity%3D%22.92%22%2F%3E%3Cpath%20d%3D%22M0%20164%20L0%20146%20Q42%20134%2082%20148%20Q112%20158%20148%20164%20Z%22%20fill%3D%22%2315153f%22%20opacity%3D%22.5%22%2F%3E%3Crect%20y%3D%22164%22%20width%3D%22400%22%20height%3D%22116%22%20fill%3D%22url%28%23se%29%22%2F%3E%3Cg%20fill%3D%22%23fff%22%20opacity%3D%22.22%22%3E%3Cellipse%20cx%3D%22286%22%20cy%3D%22172%22%20rx%3D%2215%22%20ry%3D%221.4%22%2F%3E%3Cellipse%20cx%3D%22280%22%20cy%3D%22181%22%20rx%3D%229%22%20ry%3D%221.2%22%2F%3E%3Cellipse%20cx%3D%22292%22%20cy%3D%22190%22%20rx%3D%2213%22%20ry%3D%221.3%22%2F%3E%3Cellipse%20cx%3D%22284%22%20cy%3D%22200%22%20rx%3D%227%22%20ry%3D%221.1%22%2F%3E%3Cellipse%20cx%3D%22290%22%20cy%3D%22211%22%20rx%3D%2211%22%20ry%3D%221.2%22%2F%3E%3C%2Fg%3E%3Cg%20opacity%3D%22.9%22%3E%3Cpath%20d%3D%22M226%20100%20L400%2072%20L400%20100%20Z%22%20fill%3D%22%23b86a00%22%2F%3E%3Crect%20x%3D%22232%22%20y%3D%2298%22%20width%3D%22168%22%20height%3D%22182%22%20fill%3D%22%23f6f7fc%22%2F%3E%3Crect%20x%3D%22232%22%20y%3D%2298%22%20width%3D%2215%22%20height%3D%22182%22%20fill%3D%22%23161643%22%20opacity%3D%22.12%22%2F%3E%3Cg%20fill%3D%22%23161643%22%20opacity%3D%22.1%22%3E%3Crect%20x%3D%22232%22%20y%3D%22142%22%20width%3D%22168%22%20height%3D%221.6%22%2F%3E%3Crect%20x%3D%22232%22%20y%3D%22186%22%20width%3D%22168%22%20height%3D%221.6%22%2F%3E%3Crect%20x%3D%22232%22%20y%3D%22230%22%20width%3D%22168%22%20height%3D%221.6%22%2F%3E%3C%2Fg%3E%3Cg%3E%3Cpath%20d%3D%22M258%20138%20v-16%20a11%2011%200%200%201%2022%200%20v16%20z%22%20fill%3D%22%23ffb700%22%20opacity%3D%22.92%22%2F%3E%3Cpath%20d%3D%22M300%20138%20v-16%20a11%2011%200%200%201%2022%200%20v16%20z%22%20fill%3D%22%23161643%22%20opacity%3D%22.3%22%2F%3E%3Cpath%20d%3D%22M342%20138%20v-16%20a11%2011%200%200%201%2022%200%20v16%20z%22%20fill%3D%22%23ffb700%22%20opacity%3D%22.7%22%2F%3E%3Cpath%20d%3D%22M258%20182%20v-16%20a11%2011%200%200%201%2022%200%20v16%20z%22%20fill%3D%22%23161643%22%20opacity%3D%22.3%22%2F%3E%3Cpath%20d%3D%22M300%20182%20v-16%20a11%2011%200%200%201%2022%200%20v16%20z%22%20fill%3D%22%23ffb700%22%20opacity%3D%22.88%22%2F%3E%3Cpath%20d%3D%22M342%20182%20v-16%20a11%2011%200%200%201%2022%200%20v16%20z%22%20fill%3D%22%23ffb700%22%20opacity%3D%22.35%22%2F%3E%3Cpath%20d%3D%22M258%20226%20v-16%20a11%2011%200%200%201%2022%200%20v16%20z%22%20fill%3D%22%23ffb700%22%20opacity%3D%22.8%22%2F%3E%3Cpath%20d%3D%22M300%20226%20v-16%20a11%2011%200%200%201%2022%200%20v16%20z%22%20fill%3D%22%23161643%22%20opacity%3D%22.28%22%2F%3E%3Cpath%20d%3D%22M342%20226%20v-16%20a11%2011%200%200%201%2022%200%20v16%20z%22%20fill%3D%22%23ffb700%22%20opacity%3D%22.6%22%2F%3E%3C%2Fg%3E%3Cg%20stroke%3D%22%23161643%22%20stroke-width%3D%221.4%22%20opacity%3D%22.4%22%3E%3Cpath%20d%3D%22M250%20186%20h140%22%2F%3E%3Cpath%20d%3D%22M256%20186%20v9%20M268%20186%20v9%20M280%20186%20v9%20M292%20186%20v9%20M304%20186%20v9%20M316%20186%20v9%20M328%20186%20v9%20M340%20186%20v9%20M352%20186%20v9%20M364%20186%20v9%20M376%20186%20v9%22%2F%3E%3Cpath%20d%3D%22M250%20195%20h140%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3Cg%20stroke%3D%22%230f2a3d%22%20stroke-width%3D%221%22%20opacity%3D%22.55%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M232%20118%20Q262%20132%20292%20116%20Q322%20130%20352%20114%22%2F%3E%3C%2Fg%3E%3Cg%20fill%3D%22%23ffb700%22%20opacity%3D%22.9%22%3E%3Ccircle%20cx%3D%22247%22%20cy%3D%22125%22%20r%3D%222%22%2F%3E%3Ccircle%20cx%3D%22262%22%20cy%3D%22128%22%20r%3D%222%22%2F%3E%3Ccircle%20cx%3D%22277%22%20cy%3D%22124%22%20r%3D%222%22%2F%3E%3Ccircle%20cx%3D%22292%22%20cy%3D%22116%22%20r%3D%222%22%2F%3E%3Ccircle%20cx%3D%22307%22%20cy%3D%22126%22%20r%3D%222%22%2F%3E%3Ccircle%20cx%3D%22322%22%20cy%3D%22129%22%20r%3D%222%22%2F%3E%3Ccircle%20cx%3D%22337%22%20cy%3D%22123%22%20r%3D%222%22%2F%3E%3C%2Fg%3E%3Cg%20stroke%3D%22%2315153f%22%20stroke-width%3D%225%22%20fill%3D%22none%22%20stroke-linecap%3D%22round%22%20opacity%3D%22.88%22%3E%3Cpath%20d%3D%22M48%20280%20C%2044%20238%2040%20212%2034%20188%22%2F%3E%3Cpath%20d%3D%22M34%20188%20C%2014%20174%20-4%20178%20-12%20190%22%2F%3E%3Cpath%20d%3D%22M34%20188%20C%2016%20166%2030%20150%2046%20148%22%2F%3E%3Cpath%20d%3D%22M34%20188%20C%2054%20168%2078%20172%2090%20184%22%2F%3E%3Cpath%20d%3D%22M34%20188%20C%208%20192%20-4%20206%20-8%20220%22%2F%3E%3Cpath%20d%3D%22M34%20188%20C%2056%20192%2070%20206%2074%20222%22%2F%3E%3C%2Fg%3E%3Cellipse%20cx%3D%22150%22%20cy%3D%22278%22%20rx%3D%22120%22%20ry%3D%2216%22%20fill%3D%22%2315153f%22%20opacity%3D%22.35%22%2F%3E%3C%2Fsvg%3E');
}

.photoCanvas {
  background-position: 34% 50%, 34% 50%;
}

.grain {
  position: absolute;
  inset: 0;
  opacity: 0.16;
  mix-blend-mode: overlay;
  pointer-events: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.82' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
}

.scrim {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(180deg, rgba(21, 21, 63, 0.5) 0%, rgba(21, 21, 63, 0) 34%),
    linear-gradient(
      0deg,
      rgba(21, 21, 63, 0.9) 0%,
      rgba(21, 21, 63, 0.62) 30%,
      rgba(21, 21, 63, 0.2) 58%,
      transparent 78%
    ),
    linear-gradient(rgba(21, 21, 63, 0.28), rgba(21, 21, 63, 0.28));
}

.panel::before,
.panel::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  filter: blur(64px);
  pointer-events: none;
}
.panel::before {
  width: 380px;
  height: 380px;
  top: -120px;
  right: -90px;
  background: radial-gradient(
    circle,
    color-mix(in srgb, var(--chekin-color-brand-blue) 13%, transparent),
    transparent 70%
  );
}
.panel::after {
  width: 320px;
  height: 320px;
  bottom: -120px;
  left: -70px;
  background: radial-gradient(circle, rgba(55, 224, 143, 0.12), transparent 70%);
}

.pass {
  --tear: 152px;
  -webkit-mask: radial-gradient(circle 8px at 0 var(--tear), transparent 8px, #000 8.5px),
    radial-gradient(circle 8px at 100% var(--tear), transparent 8px, #000 8.5px);
  -webkit-mask-composite: source-in;
  mask: radial-gradient(circle 8px at 0 var(--tear), transparent 8px, #000 8.5px),
    radial-gradient(circle 8px at 100% var(--tear), transparent 8px, #000 8.5px);
  mask-composite: intersect;
}

.passShell {
  filter: drop-shadow(
    0 18px 36px color-mix(in srgb, var(--chekin-color-brand-navy) 20%, transparent)
  );
}

.perforation {
  height: 1px;
  background: repeating-linear-gradient(
    90deg,
    var(--chekin-neutral-200) 0 5px,
    transparent 5px 10px
  );
}

.nightsRule {
  height: 1.5px;
  background: repeating-linear-gradient(
    90deg,
    var(--chekin-neutral-300) 0 3px,
    transparent 3px 6px
  );
}

.skeleton {
  background-color: var(--chekin-blue-650);
  background-image: linear-gradient(
    100deg,
    rgba(255, 255, 255, 0) 38%,
    rgba(255, 255, 255, 0.09) 50%,
    rgba(255, 255, 255, 0) 62%
  );
  background-size: 260% 100%;
  background-repeat: no-repeat;
  animation: arrival-skeleton 1.35s ease-in-out infinite;
}

@keyframes arrival-skeleton {
  from {
    background-position: 130% 0;
  }
  to {
    background-position: -30% 0;
  }
}

.sceneIn {
  animation: arrival-scene-in 0.28s ease-out both;
}

@keyframes arrival-scene-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .skeleton {
    animation: none;
  }

  .sceneIn {
    animation: none;
  }
}
